import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { hostTypeSelector, parentOriginSelector } from '../../../selectors';
import { EHostType } from '../../../types/hostType';
import { useApplicationContext } from '../../../utils/applicationContext';
import { postFrameMessage } from '../../../utils/postFrameMessage';

export function useFullscreenGalleryPostMessage() {
  const { logger } = useApplicationContext();
  const hostType = useSelector(hostTypeSelector);
  const targetOrigin = useSelector(parentOriginSelector);

  const onGalleryOpen = useCallback(() => {
    if (!!targetOrigin && hostType === EHostType.DesktopFrame) {
      postFrameMessage({
        message: { type: 'fullscreen', value: true },
        targetOrigin,
        logger,
      });
    }
  }, [hostType, targetOrigin, logger]);

  const onGalleryClose = useCallback(() => {
    if (!!targetOrigin && hostType === EHostType.DesktopFrame) {
      postFrameMessage({
        message: { type: 'fullscreen', value: false },
        targetOrigin,
        logger,
      });
    }
  }, [hostType, targetOrigin, logger]);

  return { onGalleryOpen, onGalleryClose };
}
